import { DropDownButton } from "@progress/kendo-react-buttons";
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { TextBox } from "@progress/kendo-react-inputs";
import { useState } from "react";

export const BarcodeFilterCell = (props: GridFilterCellProps) => {
    return StringFilterCell(props, [
        { text: 'Contains', operator: 'contains' },
        { text: 'Does Not Contain', operator: 'doesnotcontain' },
        { text: 'Starts With', operator: 'startswith' },
        { text: 'Ends With', operator: 'endswith' },
    ]);
}

export const GuidFilterCell = (props: GridFilterCellProps) => {
    return StringFilterCell(props, [
        { text: 'Equal', operator: 'eq' },
        { text: 'Not Equal', operator: 'neq' },
    ]);
}

const StringFilterCell = (props: GridFilterCellProps, items: any[]) => {
    const onValueChange = (event: any) => {
        setValue(event.value);
        if (event.value === null) {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event,
            });
        } else {
            props.onChange({
                value: event.value,
                operator: operator.operator,
                syntheticEvent: event.syntheticEvent,
            });
        }
    };
    const onOperatorChange = (event: any) => {
        setOperator(event.item);
        if (value === null) {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event,
            });
        } else {
            props.onChange({
                value: value,
                operator: event.item.operator,
                syntheticEvent: event.syntheticEvent,
            });
        }
    };
    const [value, setValue] = useState(undefined as undefined | string);
    const [operator, setOperator] = useState(items[0]);
    return (
        <div className="k-filtercell">
            <TextBox
                value={value}
                onChange={onValueChange}
            />&nbsp;
            <div className="k-filtercell-operator">
                <DropDownButton textField={"text"} onItemClick={onOperatorChange} iconClass='k-i-filter k-icon' items={items}
                ></DropDownButton>
            </div>
        </div>
    );
};